import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "sort_up",
  "use": "sort_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"sort_up\"><defs><style type=\"text/css\"></style></defs><path d=\"M194.108395 621.186771 863.223758 621.186771 528.668123 251.67295Z\" p-id=\"1078\" fill=\"#bebebe\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sort_up.svg
// module id = iYXs
// module chunks = 37